import React from 'react';
import { inject, observer } from 'mobx-react';
import { Anchor } from 'telia-front-react';
import SsoStore from '../stores/SsoStore';
import GaHelper from '../util/GaHelper';

interface LoginAnchorProps {
  ssoStore?: SsoStore;
  text: string;
  hard?: boolean;
  url: string;
  submitDataGa?: GaData;
  onClick?: (event: React.MouseEvent<HTMLAnchorElement>) => void;
}

@observer
class LoginAnchor extends React.Component<LoginAnchorProps> {
  public static defaultProps: Partial<LoginAnchorProps> = {
    hard: false
  };

  private handleClick = (event?: React.MouseEvent<HTMLAnchorElement>) => {
    const { ssoStore, hard, url, submitDataGa, onClick } = this.props;

    if (onClick) {
      onClick(event);
    }

    GaHelper.pushGaData(submitDataGa);
    return hard ? ssoStore.ensureHardLogin(url) : ssoStore.ensureLogin(url);
  };

  private loginLevelSufficient() {
    const ssoStore = this.props.ssoStore;
    return this.props.hard ? ssoStore.loggedInWithHardAuth : ssoStore.loggedIn;
  }

  public render() {
    const { url, text } = this.props;
    if (!url && this.loginLevelSufficient()) {
      return null;
    }
    return (
      <Anchor url="#" onClick={this.handleClick}>
        {text}
      </Anchor>
    );
  }
}

export default inject('ssoStore')(LoginAnchor);
